import React, {useState} from 'react';
import {GxButton, GxDropdown, GxIcon, GxMenu, GxMenuDivider, GxMenuItem} from '@garpix/garpix-web-components-react';
import {useNavigate} from 'react-router-dom';
import {useStoreon} from 'storeon/react';
import { api } from '@/api';
import { Events, State } from '@/interfaces';
import {getCookie, removeCookie, setCookie} from '../../utils';
import {useSiteConfigurations} from '../../apps/Applications/hooks';
import {PhoneIcon} from '../../assets';
import style from './styles/index.module.scss'
import Avatar from '../../assets/Base/avatar.svg';


const UserAccount = () => {
    const { dispatch, currentUser } = useStoreon<State, Events>('currentUser', 'showModalCall');
    const [operatorId, setOperatorId] = useState<string | null>(getCookie('operatorAtcNumber') );
    let navigate = useNavigate();
    const siteConfigurations = useSiteConfigurations();
    let { avatar } = currentUser;
    let userAvatar = avatar ? process.env.REACT_APP_DOMAIN_BACKEND + avatar : Avatar

    const handleClickLogout = async () => {
        await api.auth.logout();
        dispatch('currentUser/save', {...currentUser, status: false });
        navigate(siteConfigurations.page_home)
        removeCookie('operatorAtcNumber')
    };

    const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
        const data = e.target.value;
        const newData =  data.replace(/[^0-9]/g, '');
        if (data.length > 4) {
            setOperatorId(newData.slice(0,4));
            setCookie('operatorAtcNumber', newData, 365);
        }else{
            setCookie('operatorAtcNumber',newData,365);
            setOperatorId(newData)
        }
    }
    return (
        <GxDropdown className={style['dropdown']} distance={12} hoist>
            <GxButton className={style['dropdown_avatar']} slot='trigger' >
                <img src={userAvatar} alt='' width='30px' height='30px' />
            </GxButton>
            <GxMenu>
                <div className={style['mobile-block']}>
                    <img className={style['mobile-block--image']} src={userAvatar} alt='avatar' width='30px' height='30px' />
                    <span className={style['mobile-block--author']}>{`${currentUser.last_name} ${currentUser.first_name}`}</span>
                    <div className={style['mobile-block--wrapper']}>
                        <div className={style['mobile-block--wrapper']}>
                            <input value={operatorId !== null ? operatorId :''} onChange={handleChangeInput}  type='text' pattern="^[0-9]+$" className={style['mobile-block--input']}/>
                        </div>
                        <GxButton className={style['mobile-block--btn']}>
                            <GxIcon src={PhoneIcon} className={style['mobile-block--icon']}/>
                        </GxButton>
                    </div>
                </div>
                <span className={style['menu_item--subtitle']}>Страница администратора</span>
                <GxMenuItem checked>Рабочий стол</GxMenuItem>
                <GxMenuItem>Навигатор задач</GxMenuItem>
                <GxMenuDivider />
                <GxMenuItem onClick={handleClickLogout}>Выйти</GxMenuItem>
            </GxMenu>
        </GxDropdown>
    );
};

export default UserAccount;